import type { SiteControlLayout } from '@scaleaq/sitecontrol-lib';

/** Same ordering as {@link useLayoutNavigationHotkeys} (alphabetical by layout name). */
export const getLayoutsSortedByName = (layouts: SiteControlLayout[]): SiteControlLayout[] =>
  [...layouts].sort((a, b) => a.name.localeCompare(b.name));

/**
 * Next layout in cycle (wraps), matching Ctrl+Shift+Right / {@link LayoutHotkeyNames.NextLayoutKey}.
 */
export const getNextLayoutId = (
  orderedLayouts: readonly { id: string }[],
  currentLayoutId: string | undefined
): string | undefined => {
  if (!orderedLayouts.length) return undefined;
  const currentIndex = orderedLayouts.findIndex(l => l.id === currentLayoutId);
  const nextIndex =
    currentIndex < 0 || currentIndex >= orderedLayouts.length - 1 ? 0 : currentIndex + 1;
  return orderedLayouts[nextIndex].id;
};

/**
 * Previous layout in cycle (wraps), matching Ctrl+Shift+Left / {@link LayoutHotkeyNames.PreviousLayoutKey}.
 */
export const getPreviousLayoutId = (
  orderedLayouts: readonly { id: string }[],
  currentLayoutId: string | undefined
): string | undefined => {
  if (!orderedLayouts.length) return undefined;
  const currentIndex = orderedLayouts.findIndex(l => l.id === currentLayoutId);
  const prevIndex = currentIndex <= 0 ? orderedLayouts.length - 1 : currentIndex - 1;
  return orderedLayouts[prevIndex].id;
};
